// extracted by mini-css-extract-plugin
export default {"popoverBox":"FolderMoreOptions_popoverBox__TSZbo"};